import { parse } from "date-fns";
import { omitBy } from "lodash-es";
import { casesActions } from "configs";
import { useCurrentCase, useDispatch, useParams } from "duck";
import {
  AnestheticGasMedicationEnum,
  useUpdateAnestheticGasAndOxygenMutation,
  useUpdatePatientInformationMutation
} from "requests";

export const useUpdateGasAndOxygen = (caseCreationDate?: Date) => {
  const dispatch = useDispatch();
  const { id: caseId } = useParams();
  const [update] = useUpdateAnestheticGasAndOxygenMutation();
  const shouldSync = useCurrentCase(medicalCase => medicalCase.shouldSync);

  return (
    curValue: number | null,
    cellValue: any,
    name: string,
    time: string
  ) => {
    if (cellValue?.anestheticGasesId && caseCreationDate) {
      const isOxygen = name === "Oxygen L/min";
      const isInhalant = name === "Inhalant Anesthetic Agent (%)";
      const timeMonitoring = parse(
        time,
        "h:mm a",
        caseCreationDate
      ).toISOString();

      const variables = omitBy(
        {
          timeMonitoring,
          ...(isOxygen ? { oxygen: curValue } : {}),
          ...(isInhalant ? { inhalantAnestheticAgent: curValue } : {})
        },
        value => value === undefined
      );

      if (shouldSync) {
        dispatch(
          casesActions.updateAnestheticGases({
            data: {
              _id: cellValue.anestheticGasesId,
              ...variables
            },
            _id: caseId
          })
        );

        return update({
          variables: {
            input: {
              _id: cellValue.anestheticGasesId,
              ...variables
            }
          }
        });
      }

      dispatch(
        casesActions.updateAnestheticGases({
          data: {
            ...(typeof cellValue.anestheticGasesId === "number"
              ? { _id: cellValue.anestheticGasesId }
              : { fakeId: cellValue.anestheticGasesId }),
            ...variables
          },
          _id: caseId
        })
      );
    }
  };
};

export const useUpdateGasMedication = () => {
  const dispatch = useDispatch();
  const { id: caseId } = useParams();
  const [update] = useUpdatePatientInformationMutation();
  const { patientId, shouldSync } = useCurrentCase(medicalCase => ({
    patientId: medicalCase.data.client.patient._id,
    shouldSync: medicalCase.shouldSync
  }));

  return (anestheticGasMedication: AnestheticGasMedicationEnum | null) => {
    if (!anestheticGasMedication) {
      return;
    }

    dispatch(
      casesActions.updatePatientInfo({
        _id: caseId as string,
        data: { anestheticGasMedication }
      })
    );

    if (shouldSync) {
      return update({
        variables: {
          input: {
            _id: patientId,
            anestheticGasMedication
          }
        }
      });
    }
  };
};
